/* src/app/components/controls/sem-geo-map/sem-geo-map.component.css */
:host {
  --geo-ink: #0f172a;
  --geo-strong: #1e293b;
  --geo-muted: #64748b;
  --geo-faint: #94a3b8;
  --geo-line: #e2e8f0;
  --geo-rail: #f1f5f9;
  --geo-surface: #fff;
  --geo-radius: 8px;
  --geo-radius-sm: 5px;
  --geo-lift: 0 1px 2px rgba(15, 23, 42, 0.06), 0 4px 12px rgba(15, 23, 42, 0.08);
  --geo-lift-lg: 0 2px 6px rgba(176, 186, 197, 0.5), 0 14px 34px rgba(15, 23, 42, 0.12);
  display: block;
  font-family:
    Inter,
    "Segoe UI",
    sans-serif;
}
.sem-geo-map {
  width: 100%;
  margin-bottom: 12px;
}
.sem-geo-map-frame {
  position: relative;
  border-radius: 0 0 var(--geo-radius) var(--geo-radius);
}
.sem-geo-map-holder {
  width: 100%;
  min-height: 200px;
  border: 1px solid var(--geo-line);
  border-top: 0;
  border-radius: 0 0 var(--geo-radius) var(--geo-radius);
  box-shadow: var(--geo-lift);
  overflow: hidden;
  z-index: 0;
}
.sem-geo-map-frame-editing::after {
  position: absolute;
  inset: 0;
  z-index: 1001;
  box-sizing: border-box;
  border: 1px solid var(--wg-accent, #3b82f6);
  border-radius: 0 0 var(--geo-radius) var(--geo-radius);
  box-shadow: 0 0 0 3px var(--wg-accent-50, #eff6ff);
  content: "";
  pointer-events: none;
}
.sem-geo-map-edit-mode-notch {
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 1002;
  display: flex;
  align-items: center;
  gap: 7px;
  transform: translate(-50%, -1px);
  padding: 6px 14px 7px;
  border-radius: 0 0 10px 10px;
  background: var(--wg-accent, #3b82f6);
  color: #fff;
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 1;
  white-space: nowrap;
}
.sem-geo-map-edit-mode-notch::before {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  content: "";
}
.sem-geo-map-edit-toggle {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 1003;
  display: grid;
  width: 36px;
  height: 36px;
  place-items: center;
  padding: 0;
  border: 1px solid var(--geo-line);
  border-radius: 50%;
  background: var(--geo-surface);
  color: var(--geo-muted);
  box-shadow: var(--geo-lift);
  cursor: pointer;
  transition:
    background-color 150ms ease,
    border-color 150ms ease,
    color 150ms ease;
}
.sem-geo-map-edit-toggle:hover {
  border-color: var(--wg-accent-200, #bfdbfe);
  background: var(--wg-accent-50, #eff6ff);
  color: var(--wg-accent-700, #1d4ed8);
}
.sem-geo-map-edit-toggle:focus-visible {
  outline: 2px solid var(--wg-accent, #3b82f6);
  outline-offset: 2px;
}
.sem-geo-map-edit-toggle-active,
.sem-geo-map-edit-toggle-active:hover {
  border-color: var(--wg-accent, #3b82f6);
  background: var(--wg-accent, #3b82f6);
  color: #fff;
}
.sem-geo-map-edit-toggle .material-symbols-outlined {
  font-size: 19px;
  line-height: 1;
}
.sem-geo-map-popup-editor {
  position: absolute;
  right: 12px;
  bottom: 12px;
  z-index: 1003;
  width: min(340px, calc(100% - 24px));
  max-height: calc(100% - 84px);
  overflow: auto;
  border: 1px solid var(--geo-line);
  border-radius: var(--geo-radius);
  background: var(--geo-surface);
  color: var(--geo-strong);
  box-shadow: var(--geo-lift-lg);
}
.sem-geo-map-popup-editor-header {
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 46px;
  padding: 0 8px 0 14px;
  border-bottom: 1px solid var(--geo-rail);
  background: var(--geo-surface);
}
.sem-geo-map-popup-editor-pin-title {
  display: grid;
  min-width: 0;
  gap: 2px;
}
.sem-geo-map-popup-editor-pin-title span {
  color: var(--geo-faint);
  font-size: 10.5px;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.sem-geo-map-popup-editor-pin-title strong {
  overflow: hidden;
  color: var(--geo-ink);
  font-size: 13px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sem-geo-map-popup-editor-title-input {
  display: grid;
  gap: 5px;
  padding: 12px 14px 0;
  color: var(--geo-muted);
  font-size: 11.5px;
  font-weight: 500;
}
.sem-geo-map-popup-editor-note-input {
  display: grid;
  gap: 5px;
  padding: 12px 14px 0;
  color: var(--geo-muted);
  font-size: 11.5px;
  font-weight: 500;
}
.sem-geo-map-popup-editor-title-input:last-child,
.sem-geo-map-popup-editor-note-input:last-child {
  padding-bottom: 12px;
}
.sem-geo-map-popup-editor-fields {
  display: grid;
  gap: 8px;
  padding: 12px 14px;
}
.sem-geo-map-popup-editor-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) 84px 28px;
  gap: 6px;
  align-items: center;
}
.sem-geo-map-popup-editor-title-input input,
.sem-geo-map-popup-editor-note-input textarea,
.sem-geo-map-popup-editor-row input,
.sem-geo-map-popup-editor-row select {
  min-width: 0;
  height: 32px;
  box-sizing: border-box;
  padding: 0 9px;
  border: 1px solid var(--geo-line);
  border-radius: var(--geo-radius-sm);
  background: var(--geo-surface);
  color: var(--geo-strong);
  font: inherit;
  font-size: 12.5px;
  transition: border-color 120ms ease, box-shadow 120ms ease;
}
.sem-geo-map-popup-editor-title-input input::placeholder,
.sem-geo-map-popup-editor-note-input textarea::placeholder,
.sem-geo-map-popup-editor-row input::placeholder {
  color: var(--geo-faint);
}
.sem-geo-map-popup-editor-title-input input:focus,
.sem-geo-map-popup-editor-note-input textarea:focus,
.sem-geo-map-popup-editor-row input:focus,
.sem-geo-map-popup-editor-row select:focus {
  border-color: var(--wg-accent, #3b82f6);
  box-shadow: 0 0 0 3px var(--wg-accent-50, #eff6ff);
  outline: none;
}
.sem-geo-map-popup-editor-note-input textarea {
  height: auto;
  min-height: 52px;
  padding: 7px 9px;
  line-height: 1.4;
  resize: vertical;
}
.sem-geo-map-popup-editor-close,
.sem-geo-map-popup-editor-remove {
  display: grid;
  width: 28px;
  height: 28px;
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--geo-faint);
  cursor: pointer;
  transition: background-color 120ms ease, color 120ms ease;
}
.sem-geo-map-popup-editor-close:hover,
.sem-geo-map-popup-editor-remove:hover {
  background: var(--geo-rail);
  color: var(--geo-strong);
}
.sem-geo-map-popup-editor-close:focus-visible,
.sem-geo-map-popup-editor-remove:focus-visible,
.sem-geo-map-popup-editor-add:focus-visible {
  outline: 2px solid var(--wg-accent, #3b82f6);
  outline-offset: 2px;
}
.sem-geo-map-popup-editor-close .material-symbols-outlined,
.sem-geo-map-popup-editor-remove .material-symbols-outlined {
  font-size: 18px;
}
.sem-geo-map-popup-editor-add {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin: 0 14px 14px;
  padding: 4px 0;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: var(--wg-accent-600, #2563eb);
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.sem-geo-map-popup-editor-add:hover {
  color: var(--wg-accent-700, #1d4ed8);
}
.sem-geo-map-popup-editor-add .material-symbols-outlined {
  font-size: 17px;
}
.sem-geo-map-message {
  padding: 6px 0;
  color: var(--geo-muted);
  font-size: 11.5px;
}
.sem-geo-map-message-error {
  color: #e34c4c;
}
:host ::ng-deep .leaflet-container {
  background: #eef2f6;
  font-family: inherit;
  font-size: 12px;
}
:host ::ng-deep .leaflet-control-zoom {
  display: flex;
  flex-direction: column;
  gap: 6px;
  border: 0;
  background: transparent;
  box-shadow: none;
}
:host ::ng-deep .leaflet-control-zoom a,
:host ::ng-deep .leaflet-control-zoom a:first-child,
:host ::ng-deep .leaflet-control-zoom a:last-child {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  border: 1px solid var(--geo-line);
  border-radius: 50%;
  background: var(--geo-surface);
  color: var(--geo-muted);
  font-size: 18px;
  font-weight: 400;
  line-height: 1;
  box-shadow: var(--geo-lift);
  transition:
    background-color 150ms ease,
    border-color 150ms ease,
    color 150ms ease;
}
:host ::ng-deep .leaflet-control-zoom a:hover {
  border-color: var(--wg-accent-200, #bfdbfe);
  background: var(--wg-accent-50, #eff6ff);
  color: var(--wg-accent-700, #1d4ed8);
}
:host ::ng-deep .leaflet-control-zoom a:focus-visible {
  outline: 2px solid var(--wg-accent, #3b82f6);
  outline-offset: 2px;
}
:host ::ng-deep .leaflet-control-zoom a.leaflet-disabled {
  color: #cbd5e1;
  background: var(--geo-surface);
}
:host ::ng-deep .sem-geo-map-baselayer-control {
  display: flex;
  flex-direction: column;
  gap: 6px;
  border: 0;
  background: transparent;
  box-shadow: none;
}
:host ::ng-deep a.sem-geo-map-baselayer-btn {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  border: 1px solid var(--geo-line);
  border-radius: 50%;
  background: var(--geo-surface);
  color: var(--geo-muted);
  box-shadow: var(--geo-lift);
  transition:
    background-color 150ms ease,
    border-color 150ms ease,
    color 150ms ease;
}
:host ::ng-deep a.sem-geo-map-baselayer-btn svg {
  width: 17px;
  height: 17px;
}
:host ::ng-deep a.sem-geo-map-baselayer-btn:hover {
  border-color: var(--wg-accent-200, #bfdbfe);
  background: var(--wg-accent-50, #eff6ff);
  color: var(--wg-accent-700, #1d4ed8);
}
:host ::ng-deep a.sem-geo-map-baselayer-btn:focus-visible {
  outline: 2px solid var(--wg-accent, #3b82f6);
  outline-offset: 2px;
}
:host ::ng-deep a.sem-geo-map-baselayer-btn-active,
:host ::ng-deep a.sem-geo-map-baselayer-btn-active:hover {
  border-color: var(--wg-accent, #3b82f6);
  background: var(--geo-surface);
  color: var(--wg-accent, #3b82f6);
}
:host ::ng-deep .leaflet-control-scale {
  margin-bottom: 8px;
  margin-left: 10px;
}
:host ::ng-deep .leaflet-control-scale-line {
  padding: 1px 6px 2px;
  border: 1px solid var(--geo-line);
  border-top: 0;
  border-radius: 0 0 4px 4px;
  background: rgba(255, 255, 255, 0.88);
  color: var(--geo-muted);
  font-size: 10px;
  font-variant-numeric: tabular-nums;
  font-weight: 500;
  letter-spacing: 0.02em;
  line-height: 13px;
  text-shadow: none;
}
:host ::ng-deep .leaflet-control-attribution {
  padding: 2px 7px;
  border-radius: var(--geo-radius-sm) 0 0 0;
  background: rgba(255, 255, 255, 0.82);
  color: var(--geo-faint);
  font-family: inherit;
  font-size: 10px;
}
:host ::ng-deep .leaflet-control-attribution a {
  color: var(--geo-muted);
  text-decoration: none;
}
:host ::ng-deep .leaflet-control-attribution a:hover {
  text-decoration: underline;
}
:host ::ng-deep .leaflet-tooltip {
  padding: 3px 8px;
  border: 0;
  border-radius: 4px;
  background: rgba(15, 23, 42, 0.9);
  color: #fff;
  font-size: 11px;
  font-variant-numeric: tabular-nums;
  font-weight: 500;
  box-shadow: none;
}
:host ::ng-deep .leaflet-tooltip::before {
  display: none;
}
:host ::ng-deep .sem-geo-map-pin {
  background: transparent;
  border: 0;
  filter: drop-shadow(0 2px 4px rgba(15, 23, 42, 0.28));
}
:host ::ng-deep .sem-geo-map-shape-label {
  width: 0 !important;
  height: 0 !important;
  margin: 0 !important;
  border: 0;
  background: none;
  pointer-events: none;
}
:host ::ng-deep .sem-geo-map-shape-label span {
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
  color: var(--geo-ink);
  font-size: 11.5px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
  line-height: 1.1;
  white-space: nowrap;
  text-shadow:
    0 0 2px #fff,
    0 0 2px #fff,
    0 0 4px #fff,
    0 1px 1px rgba(15, 23, 42, 0.18);
}
:host ::ng-deep .sem-geo-map-bubble .leaflet-popup-content-wrapper {
  padding: 0;
  overflow: hidden;
  border: 1px solid var(--geo-line);
  border-radius: var(--geo-radius);
  background: var(--geo-surface);
  color: var(--geo-strong);
  box-shadow: var(--geo-lift-lg);
}
:host ::ng-deep .sem-geo-map-bubble .leaflet-popup-content {
  min-width: 208px;
  max-width: 300px;
  margin: 0;
  font-size: 12px;
  line-height: 1.45;
}
:host ::ng-deep .sem-geo-map-bubble .leaflet-popup-tip {
  width: 14px;
  height: 14px;
  margin: -7px auto 0;
  padding: 0;
  border: 1px solid var(--geo-line);
  border-top: 0;
  border-left: 0;
  background: var(--geo-surface);
  box-shadow: none;
}
:host ::ng-deep .sem-geo-map-bubble .leaflet-popup-tip-container {
  height: 14px;
}
@keyframes sem-geo-map-bubble-in {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
:host ::ng-deep .sem-geo-map-bubble .leaflet-popup-content-wrapper,
:host ::ng-deep .sem-geo-map-bubble .leaflet-popup-tip-container {
  animation: sem-geo-map-bubble-in 160ms ease-out both;
}
:host ::ng-deep .sem-geo-map-bubble a.leaflet-popup-close-button {
  top: 8px;
  right: 8px;
  display: grid;
  width: 22px;
  height: 22px;
  place-items: center;
  padding: 0;
  border-radius: 50%;
  color: var(--geo-faint);
  font-size: 17px;
  font-weight: 400;
  line-height: 1;
  text-decoration: none;
  transition: background-color 120ms ease, color 120ms ease;
}
:host ::ng-deep .sem-geo-map-bubble a.leaflet-popup-close-button:hover {
  background: var(--geo-rail);
  color: var(--geo-strong);
}
:host ::ng-deep .sem-geo-map-popup {
  display: grid;
  grid-template-columns: minmax(0, min(45%, max-content)) minmax(0, 1fr);
  align-items: baseline;
  column-gap: 10px;
  min-width: 0;
  padding: 13px 15px 12px;
}
:host ::ng-deep .sem-geo-map-popup-title,
:host ::ng-deep .sem-geo-map-popup-note,
:host ::ng-deep .sem-geo-map-popup-fix {
  grid-column: 1 / -1;
}
:host ::ng-deep .sem-geo-map-popup-title {
  margin: 0 26px 10px 0;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--geo-rail);
  color: var(--geo-ink);
  font-size: 13.5px;
  font-weight: 700;
  letter-spacing: -0.005em;
  line-height: 1.35;
}
:host ::ng-deep .sem-geo-map-popup-note {
  padding-bottom: 7px;
  color: var(--geo-muted);
  font-size: 12px;
  line-height: 1.5;
}
:host ::ng-deep .sem-geo-map-popup-row {
  display: contents;
}
:host ::ng-deep .sem-geo-map-popup-label,
:host ::ng-deep .sem-geo-map-popup-value {
  padding: 3px 0;
  font-size: 12px;
  line-height: 1.4;
}
:host ::ng-deep .sem-geo-map-popup-label {
  color: var(--geo-muted);
}
:host ::ng-deep .sem-geo-map-popup-value {
  color: var(--geo-strong);
  font-feature-settings: "tnum";
  font-weight: 500;
  overflow-wrap: anywhere;
}
:host ::ng-deep .sem-geo-map-popup-fix {
  display: flex;
  align-items: baseline;
  gap: 9px;
  margin: 9px -15px -12px;
  padding: 7px 15px 8px;
  border-top: 1px solid var(--geo-rail);
  background: #f8fafc;
}
:host ::ng-deep .sem-geo-map-popup-fix:first-child {
  margin-top: -13px;
  border-top: 0;
}
:host ::ng-deep .sem-geo-map-popup-crs {
  flex: 0 0 auto;
  color: var(--geo-faint);
  font-size: 9.5px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
:host ::ng-deep .sem-geo-map-popup-fix-values {
  display: grid;
  gap: 1px;
  min-width: 0;
  color: var(--geo-muted);
  font-size: 11px;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
:host ::ng-deep .sem-geo-map-popup-fix-values > span {
  display: grid;
  grid-template-columns: 22px minmax(0, 1fr);
}
:host ::ng-deep .sem-geo-map-popup-axis {
  color: var(--geo-faint);
  font-weight: 600;
}
:host ::ng-deep .sem-geo-map-line-casing,
:host ::ng-deep .sem-geo-map-line-core {
  transition: stroke-width 120ms ease, stroke-opacity 120ms ease;
}
:host ::ng-deep .sem-geo-map-line-casing {
  cursor: pointer;
}
:host ::ng-deep .sem-geo-map-distance {
  transition: opacity 420ms ease-out;
  padding: 4px 9px;
  border: 1px solid var(--geo-line);
  border-radius: 999px;
  background: var(--geo-surface);
  box-shadow: var(--geo-lift);
  color: var(--geo-ink);
  font-family:
    Inter,
    "Segoe UI",
    sans-serif;
  font-size: 11.5px;
  font-variant-numeric: tabular-nums;
  line-height: 1.2;
  white-space: nowrap;
}
:host ::ng-deep .sem-geo-map-distance::before {
  display: none;
}
:host ::ng-deep .sem-geo-map-distance-value {
  font-weight: 600;
  letter-spacing: -0.01em;
}
:host ::ng-deep .sem-geo-map-distance-unit {
  margin-left: 3px;
  color: var(--geo-faint);
  font-size: 9.5px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
@media (max-width: 640px) {
  .sem-geo-map-popup-editor-row {
    grid-template-columns: minmax(0, 1fr) 84px 28px;
  }
  .sem-geo-map-popup-editor-row input:first-child {
    grid-column: 1 / -1;
  }
}
@media (prefers-reduced-motion: reduce) {
  :host ::ng-deep .sem-geo-map-bubble .leaflet-popup-content-wrapper,
  :host ::ng-deep .sem-geo-map-bubble .leaflet-popup-tip-container {
    animation: none;
  }
  .sem-geo-map-edit-toggle,
  .sem-geo-map-popup-editor-close,
  .sem-geo-map-popup-editor-remove,
  :host ::ng-deep .sem-geo-map-line-casing,
  :host ::ng-deep .sem-geo-map-line-core,
  :host ::ng-deep .sem-geo-map-distance,
  :host ::ng-deep .leaflet-control-zoom a,
  :host ::ng-deep .sem-geo-map-baselayer-btn {
    transition: none;
  }
}
/*# sourceMappingURL=sem-geo-map.component.css.map */
